// @flow

export const MASTER_CENTRIFUGE_ACTION_TYPES: {
    M_CENTRIFUGE_SET_CONN_DATA: 'M_CENTRIFUGE_SET_CONN_DATA',
    M_CENTRIFUGE_SET_IN_PROGRESS: 'M_CENTRIFUGE_SET_IN_PROGRESS',
    M_CENTRIFUGE_SET_IS_CONNECTED: 'M_CENTRIFUGE_SET_IS_CONNECTED',
} = {
    M_CENTRIFUGE_SET_CONN_DATA: 'M_CENTRIFUGE_SET_CONN_DATA',
    M_CENTRIFUGE_SET_IN_PROGRESS: 'M_CENTRIFUGE_SET_IN_PROGRESS',
    M_CENTRIFUGE_SET_IS_CONNECTED: 'M_CENTRIFUGE_SET_IS_CONNECTED',
};

export const MASTER_CENTRIFUGE_MODULE_NAME = 'MASTER_CENTRIFUGE';
